interface Props {
  [key: string]: any
}

function ExpandIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 16 16" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        clipRule="evenodd"
        d="M10 0H16V6L14 4L10 8L8 6L12 2L10 0ZM6 16H0V10L2 12L6 8L8 10L4 14L6 16Z"
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default ExpandIcon
